import { colors } from "../../../../common/styles";
const { blackTransparent, green, red, darkGrey } = colors;
export default {
    mainHeaderContainer: {
        my: 4,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
    },
    // mainHeader: { m: 2 },
    leftContainerColumn: {
        "& > div": { borderBottom: 2, mx: 2, py: 1, borderColor: "divider" }
    },
    tabContentContainer: { borderBottom: 1, borderColor: "divider" },
    assetListContainer: { borderTop: 2, borderColor: "divider" },
    // Warning-coloured so an incomplete count is obvious on arrival. Uses the
    // same amber as nonMandatoryAssetPageBanner further down the page, so the
    // review screens warn in one voice rather than two.
    pendingCountBanner: {
        mx: 2,
        mb: 1,
        px: 2,
        py: 1,
        borderRadius: 1,
        background: "#FFF3CD",
        border: "1px solid #FFEEBA",
        color: "#856404",
        display: "flex",
        alignItems: "center",
        gap: 1
    },

    // Widths are set here rather than with Grid's md/lg/xl props: a
    // 12-column grid only steps 25% -> 16.7%, and the left pane wants 20%.
    // The Grid items carry no size props, so nothing competes with these.
    leftContainer: {
        p: 2,
        borderRight: 1,
        borderColor: "divider",
        flexBasis: "100%",
        maxWidth: "100%",
        "@media (min-width:900px)": { flexBasis: "20%", maxWidth: "20%" }
    },
    rightContainer: {
        p: 2,
        "&  .MuiDataGrid-root": { height: "80vh" },
        flexBasis: "100%",
        maxWidth: "100%",
        "@media (min-width:900px)": { flexBasis: "80%", maxWidth: "80%" }
    },
    assetProgressContainer: { position: "relative" },
    auditStatus: {
        position: "absolute",
        right: "2px",
        top: "10px"
    },
    getIconStyle: (view, selectedView) => ({
        cursor: "pointer",
        color: view !== selectedView && colors.grey
    }),
    gridItem: {
        display: "flex",
        "& > p": {
            flex: "auto"
        }
    },
    flexContainer: {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        alignItems: "flex-end",
        "& > div": { width: "50%" }
    },

    label: {
        textAlign: "left",
        textTransform: "capitalize"
    },
    count: {
        textAlign: "right"
    },
    flexGrow: {
        flexGrow: 1
    },
    spacer: {
        my: 2
    },
    primaryButton: {
        backgroundColor: colors.blue,
        color: colors.white,
        borderRadius: 32,
        px: 2,
        py: 1,
        ":hover": {
            backgroundColor: colors.blue,
            color: colors.white
        }
    },
    secondaryButton: {
        backgroundColor: colors.mediumGrey,
        color: colors.black,
        borderRadius: 32,
        px: 2,
        py: 1,
        ":hover": {
            backgroundColor: colors.mediumGrey,
            color: colors.black
        }
    }
};
